import React from "react";
import * as Icon from "react-feather";
import "./engagement-budget-card.css";

class EngagementBudgetCard extends React.Component {
	render() {
		const { budget, index, onRemoveBudget } = this.props;

		return (
			<div key={index} className="eng-budgets">
				<div className="eng-budget-card">
					<div className="eng-budget-card__content">
						<div className="eng-budget-card__content__assigned">
							<Icon.Clock size={14} color="var(--primary-main)" />
							<span className="eng-budget-card__content__assigned__value">{budget.budget}</span>
						</div>

						<div className="eng-budget-card__content__divider" />

						<span className="eng-budget-card__content__title">{budget.resource}</span>
					</div>

					<Icon.XCircle
						className="eng-budget-card__remove-budget-icon"
						size={28}
						color="#FF6B6B"
						onClick={(e) => {
							e.stopPropagation();
							onRemoveBudget(index);
						}}
					/>
				</div>
			</div>
		);
	}
}

export default EngagementBudgetCard;
